import '../assets/NcAppNavigationSpacer-BJj8CIpA.css';
import { createElementBlock, openBlock } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _sfc_main = {
  name: "NcAppNavigationSpacer"
};
const _hoisted_1 = { class: "app-navigation-spacer" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("li", _hoisted_1);
}
const NcAppNavigationSpacer = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-b699c557"]]);
export {
  NcAppNavigationSpacer as N
};
//# sourceMappingURL=NcAppNavigationSpacer-CzBLuQL8.mjs.map
